module.exports = "/images/vendor/flag-icon-css/flags/4x3/tz.svg?88c89454adfe247406b430a46c965da8";